
export interface ItemsSelectionQueryVariables {
    selectionId?: string
}

export interface ItemAttribute {
    // Data model attributes which are defined in 'media_asset' layout.
    [key: string]: string | boolean | number;

    // Meta properties:
    __asset_attribute: string; // Attribute name
    __type: 'image' | 'doc';
    __asset: string; // Attribute value
    __asset_seqno: number;
    __seq_amazon: string;
    __seq_num: number;

    // UI properties:
    __itemPrimaryKey: string;
    __selected: boolean;

}

export enum GalleryMode {
    SMALL = 'small',
    LARGE = 'large'
}

export interface RunExportRequestPayload {
    items: {
        [key: string]: ItemAttribute[]
    };
    namingPattern: string;
}

export interface NamingPatterns {
    [key: string]: string;
}

export interface ItemsSelectionResponse {
    // Each key represents an item primary key, while the value
    // is the item attributes which contain a media asset (Image/Document attributes).
    [key: string]: ItemAttribute[];
}
